import { useMemo } from "react";

import { FlowsProjectRolesBulkActionItem } from "../types";
import useUnassignFlowsProjectRolesBulkAction from "./useUnassignBulkAction";

const useFlowsProjectRolesBulkActions = (): FlowsProjectRolesBulkActionItem[] => {
  const unassignFlowsProjectRolesBulkAction = useUnassignFlowsProjectRolesBulkAction();

  return useMemo(
    () => [unassignFlowsProjectRolesBulkAction],
    [unassignFlowsProjectRolesBulkAction]
  );
};

export default useFlowsProjectRolesBulkActions;
